import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = () => {
  const { authToken, user } = useAuth();

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "admin") {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
